import { Menu } from "@headlessui/react";
import React from "react";

type DropdownMenuTriggerProps = {
    children: ({ open }: { open: boolean }) => React.ReactNode;
    className?: string;
};

const DropdownMenuTrigger = React.forwardRef<
    HTMLButtonElement,
    DropdownMenuTriggerProps
>(({ className, children }, forwardedRef) => {
    return (
        <Menu.Button className={className} ref={forwardedRef}>
            {({ open }) => <>{children({ open })}</>}
        </Menu.Button>
    );
});

export default DropdownMenuTrigger;
